import React, { useEffect, useState } from "react";
import popupImg from "../images/comp/popup-img.webp";

const QuotePopup = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    project: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    window.openQuotePopup = () => {
      const popup = document.getElementById("popup");
      if (popup) {
        popup.style.display = "flex";
        document.body.style.overflow = "hidden";

        setTimeout(() => {
          popup.classList.add("show");
          popup.classList.remove("hide");
        }, 10);
      }
    };

    window.closeQuotePopup = () => {
      const popup = document.getElementById("popup");
      if (popup) {
        popup.classList.remove("show");
        popup.classList.add("hide");
        document.body.style.overflow = "";

        setTimeout(() => {
          popup.style.display = "none";
        }, 300);
      }
    };

    return () => {
      delete window.openQuotePopup;
      delete window.closeQuotePopup;
      document.body.style.overflow = "";
    };
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");

    try {
      const API_URL = "https://www.hopewebsolution.com/api/submit.php";

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      const data = await response.json();

      if (data.success) {
        setSuccessMsg("Thank you! We’ll contact you shortly.");
        setForm({ name: "", email: "", phone: "", project: "" });

        setTimeout(() => {
          window.closeQuotePopup?.();
          setSuccessMsg("");
        }, 2000);
      } else {
        setErrorMsg(data.message || "Something went wrong.");
      }
    } catch (error) {
      setErrorMsg("Server error. Please try again later.");
    }

    setLoading(false);
  };

  // =========================
  // JSX
  // =========================
  return (
    <div
      id="popup"
      className="popup"
      onClick={(e) => {
        if (e.target.id === "popup") {
          window.closeQuotePopup?.();
        }
      }}
    >
      <div className="popup-content">
        <span
          className="popup-close"
          onClick={() => window.closeQuotePopup?.()}
        >
          &times;
        </span>

        <div className="popup-flex">
          {/* LEFT IMAGE */}
          <div className="popup-img-side">
            <img src={popupImg} className="img-fluid" alt="Consultation" />
          </div>

          {/* RIGHT FORM */}
          <div className="popup-form-side">
            <h2 className="title">Get a Free Consultation Today!</h2>
            <p className="sub-title">
              With our expertise and dedication, we’re ready to help turn your
              brand into the next success story.
            </p>

            <form onSubmit={handleSubmit} autoComplete="off">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={form.name}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
                required
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                value={form.phone}
                onChange={handleChange}
                required
              />

              <textarea
                name="project"
                placeholder="Tell us about your project"
                value={form.project}
                onChange={handleChange}
                required
              />

              {/* STATUS MESSAGES */}
              {errorMsg && <p className="error-msg">{errorMsg}</p>}
              {successMsg && <p className="success-msg">{successMsg}</p>}

              <button type="submit" className="btn-orange" disabled={loading}>
                {loading ? "Submitting..." : "Get Quote"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotePopup;
